<template>
  <q-dialog ref="dialogRef" @hide="onDialogHide" persistent>
    <ml-dialog-content @dialog:close="onCancel" rowActions>
      <template #title>
        {{ title }}
      </template>
      <template #content>
        <div>{{ $t('dialog_confirmation.content') }}</div>
        <div v-if="text">{{ text }}</div>
      </template>
      <template #actions>
        <ml-element-button
          outline
          bg-color="on-secondary-muted"
          :disable="loading"
          :label="$t('dialog_confirmation.cancel')"
          @click="onCancel"
        />
        <ml-element-button
          :data-cy="dataCy?.confirm"
          :loading="loading"
          :label="$t('dialog_confirmation.confirm')"
          @click="onOKClick"
        />
      </template>
    </ml-dialog-content>
  </q-dialog>
</template>

<script setup lang="ts">
import { useDialogPluginComponent } from 'quasar'
import { ref } from 'vue'

import MlDialogContent from 'components/blocks/dialog/MlDialogContent.vue'
import MlElementButton from 'components/elements/buttons/MlElementButton.vue'
import { ConfirmationDialogOptions } from 'src/services/Dialoger'

const loading = ref(false)

const props = defineProps<{
  onConfirm?: () => Promise<void>
  text?: string
  title?: string
  dataCy?: ConfirmationDialogOptions['dataCy']
}>()

defineEmits([...useDialogPluginComponent.emits])
const { dialogRef, onDialogHide, onDialogOK, onDialogCancel } =
  useDialogPluginComponent()

async function onOKClick() {
  loading.value = true
  try {
    if (props.onConfirm) {
      await props.onConfirm()
    }
  } finally {
    loading.value = false
    onDialogOK()
  }
}

function onCancel() {
  onDialogCancel()
}
</script>
